<template>
  <div class="color-sample-rim">
    <div class="color-sample m1-a">
      <section class="spacer" />
      <section class="flex center grow adjust-bottom">
        <div class="box bottom">
          <p class="smaller-text">
            享年 八十八歳
          </p>
        </div>
      </section>
      <section class="flex center grow adjust-bottom-2">
        <div class="box bottom">
          <p class="small-text">
            俗名 源頼朝
          </p>
        </div>
      </section>
      <section>
        <p class="default-text">
          武皇嘯厚大禅門
        </p>
      </section>
      <section>
        <p class="small-text">
          令和元年十二月二十八日
        </p>
      </section>
      <section class="spacer" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-front.scss";
</style>
